import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.a`
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: ${window?.settings?.secondary_color ?? '#04333B'};
    text-decoration-line: underline;
`;


export default Atom({ type: 'link', template })

